import { appStringMap } from "./appStringMap";
import { AppString } from "./types";

export function t(str: AppString, parameters?: Record<string, any>): string {
  // Ensure str is treated as a string
  const stringKey = str as string;
  
  // Split the input key by dot to navigate the nested structure
  const keys = stringKey.split(".");
  let value: any = appStringMap;

  for (const key of keys) {
    if (value.hasOwnProperty(key)) {
      value = value[key];
    } else {
      throw new Error(`Invalid appString key: ${str}`);
    }
  }


  if (typeof value === "string") {
    return value;
  } else {
    throw new Error(`Invalid appString key: ${str}`);
  }
}